import { GetStripeMeterLogsResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { adminKeys } from "../queryKeys";

const getOrganizationMeterLogs = async (
  orgId: string,
  subscriptionLinkId: string
) => {
  const resp = await api.get<GetStripeMeterLogsResponseBodyType>(
    `/v2/admin/meter-logs/${orgId}/${subscriptionLinkId}`
  );
  return resp.data;
};

export const useGetOrganizationMeterLogs = (
  orgId: string,
  subscriptionLinkId: string
) => {
  return useQuery<GetStripeMeterLogsResponseBodyType, Error>({
    queryKey: adminKeys.meterLogs(subscriptionLinkId),
    queryFn: async () => getOrganizationMeterLogs(orgId, subscriptionLinkId),
  });
};
